import {getDataWithPromise, Globals, handleAjaxError, urlExplode} from "./BaseDataFns";

export const getWorkItemsForUser = ( user_id, onComplete ) =>
{
    const url = Globals.APIFolder + urlExplode ( '/users/{user_id}/workitems', {user_id: user_id } ) ;

    getDataWithPromise ( url, 'GET', {} )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const getWorkItemWithPromise = ( workitem_id ) =>
{
    const url = Globals.APIFolder + urlExplode ( '/workitems/{workitem_id}', {workitem_id: workitem_id } ) ;

    return getDataWithPromise ( url, 'GET', {} ) ;
}
